import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import { PageTitleProvider } from './contexts/PageTitleContext';

import BaseLayout from './app/BaseLayout';
import Login from './app_user/Login';
import Welcome from './app_user/Welcome';
import Dashboard from './app_user/pages/dashboard/Dashboard';
import Home from './app_user/Home';
import MySequences from './app_user/pages/sequences/mySequences/MySequences';
import SequenceDatails from './app_user/pages/sequences/mySequences/SequenceDetails/SequenceDetails';
import Panel from './app_user/pages/sequences/mySequences/SequenceDetails/tabs/Panel';
import EmailsSequences from './app_user/pages/sequences/mySequences/SequenceDetails/tabs/EmailsSequences';
import ReportSequence from './app_user/pages/sequences/mySequences/SequenceDetails/tabs/ReportSequence/ReportSequence';
import NewReport from './app_user/pages/sequences/mySequences/SequenceDetails/tabs/ReportSequence/NewReport';
import TemplatesSequencia from './app_user/pages/sequences/TemplatesSequence';
import Lists from './app_user/pages/tasks/TodoDo';
import Recurrent from './app_user/pages/tasks/Recurrent/Recurrent';
import Companies from './app_user/pages/companies/Clientes';
import Collaborators from './app_user/pages/companies/Collaborators';
import Record from './app_user/pages/companies/Record/Record';
import Registrations from './app_user/pages/personalization/Registration/Registrations';
import ListOfOrders from './app_user/pages/personalization/ListOfOrders/ListOfOrders';
import Automations from './app_user/pages/personalization/Automations/Automations';
import AutomationDetails from './app_user/pages/personalization/Automations/AutomationDetails';
import Folders from './app_user/pages/files/Folders/Folders';
import TakeFiles from './app_user/pages/files/TakeFiles/TakeFiles';
import Emails from './app_user/pages/personalization/emails/Emails';
import Profile from './app_user/pages/profile/Profile';
import AdministrativePanel from './app_user/pages/profile/AdministrativePanel/AdministrativePanel';
import Notification from './app_user/Notification';

function App() {
  return (
    <Router>
      <PageTitleProvider>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/login" element={<Login />} />

          <Route element={<BaseLayout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/sequencia" element={<MySequences />} />
            <Route path="/detalhes-sequencia" element={<SequenceDatails />} />
            <Route path="/painel-sequencia" element={<Panel />} />
            <Route path="/emails-sequencia" element={<EmailsSequences />} />
            <Route path="/report-sequencia" element={<ReportSequence />} />
            <Route path="/new-report" element={<NewReport />} />
            <Route path="/templates" element={<TemplatesSequencia />} />
            <Route path="/todo_do" element={<Lists />} />
            <Route path="/detalhes_tarefas" element={<Recurrent />} />
            <Route path="/clientes" element={<Companies />} />
            <Route path="/colaboradores" element={<Collaborators />} />
            <Route path="/record" element={<Record />} />
            <Route path="/configurações" element={<Registrations />} />
            <Route path="/lista-ordens" element={<ListOfOrders />} />
            <Route path="/lista-automacoes" element={<Automations />} />
            <Route path="/lista-automacoes/:id" element={<AutomationDetails />} />
            <Route path="/folders" element={<Folders />} />
            <Route path="/leva-arquivos" element={<TakeFiles />} />
            <Route path="/emails" element={<Emails />} />
            <Route path="/perfil" element={<Profile />} />
            <Route path="/painel-administrativo" element={<AdministrativePanel />} />
            <Route path="/notification" element={<Notification />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </PageTitleProvider>
    </Router>
  );
}

export default App;
